import Vue from 'vue'
import Vuex from 'vuex'
import {
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
  parseJsonStorage,
  setAuthSession,
  clearAuthSession,
  getAuthToken,
} from '@/lib/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authState: {
      token: getAuthToken(),
      loggedUser: parseJsonStorage(AUTH_USER_KEY, null),
      status: getAuthToken() ? 'logged' : 'notlogged',
    },
    settings: {},
    process: parseJsonStorage('process', {}),
    control: parseJsonStorage('control', {}),
  },
  getters: {
    isAuthenticated: state => !!state.authState.token,
    authStatus: state => state.authState.status,
    loggedUser: state => state.authState.loggedUser,
    settings: state => state.settings,
  },
  mutations: {
    saveControl(state, control) {
      localStorage.setItem('control', JSON.stringify(control))
      state.control = control
    },
    controlReset(state) {
      localStorage.setItem('control', '{}')
      Vue.set(state.control, {})
    },
    saveProcess(state, process) {
      localStorage.setItem('process', JSON.stringify(process))
      state.process = process
    },
    processStepDone(state, stepDone) {
      state.process.steps.forEach((step) => {
        if (step.step === stepDone) {
          step.done = true
        }
      })
      localStorage.setItem('process', JSON.stringify(state.process))
    },
    authSuccess(state, { token, loggedUser }) {
      state.authState.status = 'logged'
      state.authState.token = token
      state.authState.loggedUser = loggedUser
      setAuthSession(token, loggedUser)
    },
    logout(state) {
      state.authState.token = ''
      state.authState.loggedUser = null
      state.authState.status = 'notlogged'
      clearAuthSession()
    },
    storeSettings(state, settings) {
      state.settings = settings
    },
  },
  actions: {},
})
